import { ANALYTICS_PAGES } from '../../../../constants/analytics'
import { useAuth } from '../../../../hooks/use-auth'
import { usePageView } from '../../../../hooks/use-page-view'
import { useCarrierOnboarding } from '../_context/carrier-onboarding-context'
import { useCarrierWorkspaceSetup } from '../_hooks/use-carrier-workspace-setup'
import { useStepCompletion } from '../_hooks/use-step-completion'
import { getIncompleteSteps } from '../_utils'
import { CarrierVerificationChecklist } from './carrier-verification-checklist'

export const CarrierOnboardingPageContent = () => {
  usePageView(ANALYTICS_PAGES.carrierOnboarding)
  const { completedStepIDs } = useCarrierOnboarding()
  const { selectedWorkspace } = useAuth()

  // Handle automatic workspace setup for carrier users
  const { filteredSteps } = useCarrierWorkspaceSetup()

  // Handle automatic step completion based on user state
  useStepCompletion()

  // Calculate incomplete steps based on current state
  const incompleteSteps = getIncompleteSteps(selectedWorkspace?.accessType, completedStepIDs)

  return (
    <div className="min-h-screen py-4 px-4 sm:py-8 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 xl:gap-12 items-start">
          {/* The step content - mobile: full width, desktop: 70% width */}
          <div className="w-full lg:w-[70%] order-2 lg:order-1">
            <div className="rounded-lg p-4 sm:p-6 lg:p-8">
              <div key={incompleteSteps[0]?.id}>{incompleteSteps[0]?.content}</div>
            </div>
          </div>

          {/* The checklist component - mobile: full width, desktop: 30% width */}
          <div className="w-full lg:w-[30%] order-1 lg:order-2">
            <div className="rounded-lg p-4 sm:p-6 lg:p-8">
              <CarrierVerificationChecklist
                steps={filteredSteps}
                currentStep={
                  incompleteSteps[0] ? filteredSteps.findIndex((step) => step.id === incompleteSteps[0].id) : 0
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
